import templateCompiler from './template.art';
import { 
    HELP_MAP 
} from "../constants/fw.help.constants";
const template = templateCompiler(HELP_MAP);
export default function ConvertModule() {
    //let callbacks = bindCallbacks(CONVERT_LIST, callback);
    let ACTIONS = window.UIExtension.UIConsts.FRAGMENT_ACTION;
    let fragments = [
        {
            // 向末尾追加控件
            action: ACTIONS.AFTER,
            // 目标控件名称， 控件将被添加这个空间里面，必须确保它是一个容器类型的控件
            target: 'protect-tab',
            // 定义控件的以及图标，文字等信息
            template: '<gtab text="phantom_online:toolbar.tabs.help.title" name="help-tab" group="toolbar-tab" body="fv--fw-help-tab-paddle" @portfolio.unsupport></gtab>',
        },
        {
            action: ACTIONS.APPEND,
            target: 'toolbar-tab-bodies',
            template: template,
        },
    ];
    return {fragments};
}
